var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFenceBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 119,
    viewBox: "0 0 380 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.627 0V19.7785H91.4663V0H71.8137V19.7785H17.9663V0H0V118.671H17.9663V98.8927H71.8137V118.671H91.4663V98.8927H143.627V118.671H161.966V98.8927H215.441V118.671H234.966V98.8927H287.255V118.671H306.466V98.8927H359.068V118.671H379.966V0H359.068V19.7785H306.466V0H287.255V19.7785H234.966V0H215.441V19.7785H161.966V0H143.627ZM17.9663 36.502H71.8137V82.1709H17.9663V36.502ZM91.4663 36.502H143.627V82.1709H91.4663V36.502ZM161.966 36.502H215.441V82.1709H161.966V36.502ZM234.966 36.502H287.255V82.1709H234.966V36.502ZM306.466 36.502H359.068V82.1709H306.466V36.502Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFenceBackground);
export default __webpack_public_path__ + "static/media/fence-background.4e91ab0a267b115ae8e3bc5f7aaf3bbc.svg";
export { ForwardRef as ReactComponent };